import { usePendingEnvironmentSwitch } from "@src/config/usePendingEnvironmentSwitch";
import { LoadingScreen } from "@src/features/auth/components/LoadingScreen";

export default function SwitchEnvironmentScreen() {
  usePendingEnvironmentSwitch();
  return <LoadingScreen message="Switching environment…" />;
}
